import React from 'react';
import HoverMenu from 'ats/components/hover-menu/HoverMenu';
import { currencyStore } from './CurrencyStore';
import { CurrencyForm } from './CurrencyForm';
import { ListStore } from '../../../shared/stores/ListStore';
import { observer } from 'mobx-react';
import SettingsTableSkeleton from '../SettingsTableSkeleton';
import {
	rolesAllowed,
	USER_ROLES
} from '../../../shared/security/RolesAllowed';
import moment from 'moment';
import SettingsSubsectionHeader from '../SettingsSubsectionHeader';
import SettingsListToolbar from '../SettingsListToolbar';
import SettingsListEmptyState from '../SettingsListEmptyState';
import { getSettingsSectionLabel } from '../settingsSections';

@rolesAllowed([USER_ROLES.ADMIN])
@observer
export class Currencies extends React.Component {
	state = {
		data: [],
		filterText: '',
		loading: true
	};

	constructor(props) {
		super(props);

		this.listStore = new ListStore(currencyStore, {
			entityName: 'Currency',
			createModal: (
				<CurrencyForm
					key="create"
					handleSuccess={() => {
						this.search();
						this.setState({ filterText: '' });
					}}
				/>
			),
			editModal: item => (
				<CurrencyForm
					key={item.id}
					data={item}
					handleSuccess={() => {
						this.search();
						this.setState({ filterText: '' });
					}}
				/>
			)
		});
	}

	componentDidMount() {
		this.search();
	}

	search(value = '') {
		this.setState({ loading: true });

		currencyStore.getCurrencies(value).then(result => {
			if (result.status === 'success' && result.data) {
				this.setState({ data: result.data, loading: false });
			}
		});
	}

	hasFilters = () => Boolean(this.state.filterText.trim());

	clearFilters = () => {
		this.setState({ filterText: '' }, () => {
			this.search();
		});
	};

	getMenuItems(row) {
		return [
			{
				label: 'Edit',
				img: '/ats/icons/edit-icon.svg',
				onClick: () => this.listStore.handleEdit(row)
			},
			{
				label: 'Delete',
				img: '/ats/icons/trash-icon.svg',
				className: 'is-danger',
				onClick: () =>
					this.listStore.handleDelete(row, this.onDeleteSuccess, true)
			}
		];
	}

	render() {
		const { data, loading, filterText } = this.state;
		const isEmpty = !loading && data.length === 0;

		return (
			<div className="Currencies container">
				<SettingsSubsectionHeader
					title={getSettingsSectionLabel('currencies')}
					actions={
						<SettingsListToolbar
							searchValue={filterText}
							onSearchChange={value => {
								this.search(value);
								this.setState({ filterText: value });
							}}
							createLabel={`Create ${this.listStore.modalsConfigs.entityName}`}
							onCreate={() => this.listStore.handleCreate()}
						/>
					}
				/>
				<div className="columns">
					<div className="column is-12 table-wrapper">
						<table className="table is-fullwidth">
							<thead>
								<tr>
									<th className="column-header-name">Name</th>
									<th className="column-header-symbol">Symbol</th>
									<th className="column-header-code">Code</th>
									<th className="column-header-USDExchangeRate">
										USD Exchange Rate
									</th>
									<th className="column-header-createdAt">Created At</th>
									<th className="column-header-updatedAt">Updated At</th>
									<th className="actions-column" />
								</tr>
							</thead>
							{loading ? (
								<SettingsTableSkeleton columns={7} />
							) : !isEmpty ? (
								<tbody>
									{data.map(row => {
										return (
											<tr key={row.id}>
												<td className="has-text-weight-bold column-name">
													{row.name}
												</td>
												<td className="column-symbol">{row.symbol}</td>
												<td className="column-code">{row.code}</td>
												<td className="column-USDExchangeRate">
													{row.USDExchangeRate}
												</td>
												<td
													className="column-createdAt tooltip is-tooltip-top"
													data-tooltip={moment(row.createdAt).format('lll')}>
													{moment(row.createdAt).format('ll')}
												</td>
												<td
													className="column-updatedAt tooltip is-tooltip-top"
													data-tooltip={moment(row.updatedAt).format('lll')}>
													{moment(row.updatedAt).format('ll')}
												</td>

												<td className="actions-column">
													<HoverMenu
														id={row.id}
														position="left"
														buttonIcon={
															<img
																src="/ats/icons/three-dots-icon.svg"
																alt="More actions"
															/>
														}
														items={this.getMenuItems(row)}
													/>
												</td>
											</tr>
										);
									})}
								</tbody>
							) : null}
						</table>
						{!loading && isEmpty ? (
							<SettingsListEmptyState
								entityPlural="currencies"
								hasFilters={this.hasFilters()}
								onClearFilters={this.clearFilters}
							/>
						) : null}
					</div>
				</div>
			</div>
		);
	}

	onDeleteSuccess = item => {
		this.search();
		this.setState({ filterText: '' });
	};
}
